/*
    This runs on everypage load, once document has loaded
    check to see if we have bopisDisplay, userlat and userLon in
    sessionStorage. If we don't, this is the first page
    they've visited and we need to call an API to get it.
    If we do, set cssVariable to hide/display modules

    We get the user coords from ipapi
    We get the store coords from a fake product that can't be deleted, handle: 'bopis' 
        (if deleted, bopis will always show)
    
    We need to see if the closest location is within 80 miles, if so show:
        listing card module - DONE
        pdp module - DONE
        TODO: eventually distance from each location in drawer (driving or by the crow flies?)
        
    Remaining QA:
        //hows the content shift if we land on a  pdp/collection page
        //make sure if deleted bopis will always show
*/
    //TODO: how do we avoid calling shopify API with every page change, can we store location in session storage

let locationPromise;

if (document.readyState !== 'loading') {
    //console.log('document is already ready, just execute code here');
    locationPromise = myInitCode();
} else {
    document.addEventListener('DOMContentLoaded', function () {
       // console.log('document was not ready, place code here');
        locationPromise = myInitCode();
    });
}

function myInitCode() {
    console.log("debug - myInitCode");

    return new Promise((resolve, reject) => {
        // Get userLocation data
        let userLocation = JSON.parse(window.sessionStorage.getItem("userLocation"));

        console.log(userLocation);

        if (userLocation?.lat && userLocation?.lon && userLocation?.zipcode) {

            let bopis = JSON.parse(window.sessionStorage.getItem("bopis"));
            let stores = JSON.parse(window.sessionStorage.getItem("stores"));

            if (bopis == null || stores == null) {
                getAllStoresAndClosestBopisStore({ lat: userLocation.lat, lon: userLocation.lon, zipcode: userLocation.zipcode }, (stores == null), (bopis == null))
                    .then(() => {
                        resolve(); // Resolve after successful data fetch
                    })
                    .catch((error) => {
                        console.error("Error fetching data:", error);
                        document.body.style.setProperty("--bopis-display", "block");
                        reject(error); // Reject the promise on error
                    });
            } else {
                if (bopis) {
                    setBopisCssVariable(bopis.display);
                }
                if (stores) {
                    injectLocationWidget(stores.preferred);
                }
                resolve(); // Resolve if data exists
            }
        } else {
            getUserCoords()
                .then(() => {
                    let userLocation = JSON.parse(window.sessionStorage.getItem("userLocation"));
                    return getAllStoresAndClosestBopisStore({ lat: userLocation.lat, lon: userLocation.lon, zipcode: userLocation.zipcode }, true, true);
                })
                .then(() => {
                    resolve(); // Resolve after fetching user coordinates and stores
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    document.body.style.setProperty("--bopis-display", "block");
                    reject(error); // Reject the promise on error
                });
        }
    });
}

//API call to get userLocation
function getUserCoords() {
    console.log("debug - getUserCoords - useiPapiAPI");

    return new Promise((resolve, reject) => {
        fetch('https://ipapi.co/json/?key=XJ1dWf0FbzAbuK9XNVO53JxZSh0rWoKoSTWIqcMhQBFfCZgAVD')
            .then(response => response.json())
            .then(data => {
                if (data.latitude && data.longitude) {

                    console.log("lat/lng", data.latitude, data.longitude);

                    //For some reason ipapi is returning some random address in CA or UT for all users in the corporate office
                    // I want to override that so if ipapi returns anywhere close to there, override to Addison coords
                    let addisonCoords = { latitude: 32.9532306, longitude: -96.8138811, postal: "75254" };
                    let iPapiCaCoords = { latitude: 37.9043, longitude: -122.0584 };
                    let iPapiUtCoords = { latitude: 40.48967, longitude: -111.93882};
                    let ipapiMaCoords = { latitude: 42.3388, longitude: -71.0726 };
                    let returnedCoordsAndCaAddressDistance = pythagoreanDistanceBetweenPoints(data.latitude, data.longitude, iPapiCaCoords.latitude, iPapiCaCoords.longitude ); 
                    let returnedCoordsAndUtAddressDistance = pythagoreanDistanceBetweenPoints(data.latitude, data.longitude, iPapiUtCoords.latitude, iPapiUtCoords.longitude ); 
                    let returnedCoordsAndMaAddressDistance = pythagoreanDistanceBetweenPoints(data.latitude, data.longitude, ipapiMaCoords.latitude, ipapiMaCoords.longitude ); 
                    if ( returnedCoordsAndCaAddressDistance < 100 || returnedCoordsAndUtAddressDistance < 100 || returnedCoordsAndMaAddressDistance < 100) {
                        data.latitude = addisonCoords.latitude;
                        data.longitude = addisonCoords.longitude;
                        data.postal = addisonCoords.postal;
                    }
                    window.sessionStorage.setItem("userLocation", JSON.stringify({lat: data.latitude, lon: data.longitude, zipcode: data.postal }));
                }
                resolve(); // Resolve promise after setting coordinates
            })
            .catch(error => {
                console.error("Error fetching user coordinates:", error);
                reject(error); // Reject promise on error
            });
    }); 
}

//API call to get bopis and/or stores data
function getAllStoresAndClosestBopisStore(userLocation, setStoresData, setBopisData) {
    console.log("debug - getAllStoresAndClosestBopisStore");

    return new Promise((resolve, reject) => {
        fetch(`${window.Shopify.routes.root}products/bopis?section_id=all-stores-and-closest-bopis-store`)
            .then(response => response.text())
            .then(text => {
                const html = new DOMParser().parseFromString(text, "text/html");
                const section = html.querySelector(".shopify-section");
                if (section) {

                    if (setBopisData){
                        const closestBopisStoreLat = section.querySelector(".latitude")?.textContent;
                        const closestBopisStoreLon = section.querySelector(".longitude")?.textContent;

                        if (closestBopisStoreLat && closestBopisStoreLon) {
                            prepareBopisData(userLocation, closestBopisStoreLat, closestBopisStoreLon);
                            resolve(); // Resolve promise after setting store coordinates

                        } else {
                            reject("Latitude or longitude missing in the response.");
                        }
                    }

                    if (setStoresData){
                        const allStoresArray = section.querySelectorAll('#stores .store');
                        if (allStoresArray) {
                            // Create an array to hold the JSON data
                            const storesArray = Array.from(allStoresArray).map(store => {
                                let storeLat = store.getAttribute('data-lat');
                                let storeLon = store.getAttribute('data-lon');

                                return {
                                    title: store.getAttribute('data-title'),
                                    rel_url: store.getAttribute('data-url'),
                                    lat: parseFloat(storeLat),
                                    lon: parseFloat(storeLon),
                                    distance: pythagoreanDistanceBetweenPoints(userLocation.lat, userLocation.lon, storeLat, storeLon)
                                };
                            });

                            prepareStoresData({openStores: storesArray}, userLocation);
                            resolve(); // Resolve promise after setting store coordinates
                        } else {
                            reject("Stores json missing in the response.");
                        }
                    }
                } else {
                    reject("Unable to find the expected section in the response.");
                }
            })
            .catch(error => {
                console.error("Error fetching store coordinates:", error);
                reject(error); // Reject promise on error
            });

    });
}

//prep and set bopis data into session storage
function prepareBopisData(userLocation, bopisStoreLat, bopisStoreLon) {
    console.log("debug - prepareBopisData");

    const closestBopisStoreDistance = pythagoreanDistanceBetweenPoints(userLocation.lat, userLocation.lon, bopisStoreLat, bopisStoreLon);

    // let bopisDisplay = "none"; //Always show for now, also this was kind of buggy. Sometimes it would say the closest store was further than it was
    let bopisDisplay = "block";

    //80 miles by the crow flies, not driving distance
    if (closestBopisStoreDistance < 80) {
        bopisDisplay = "block";
    }

    window.sessionStorage.setItem("bopis", JSON.stringify(
        {
            display: bopisDisplay,
            closestStore: {
                title: null, //may want to set these in the future if we need them, would need to match pickup_availabilities.location[0] to stores array generated from html, and use the additional data we could pull from the html source that the pickup_availabilities source doesn't provide
                rel_url: null, //may want to set these in the future if we need them, would need to match pickup_availabilities.location[0] to stores array generated from html, and use the additional data we could pull from the html source that the pickup_availabilities source doesn't provide
                lat: bopisStoreLat,
                lon: bopisStoreLon,
                distance: closestBopisStoreDistance
            }
        }
    ));

    setBopisCssVariable(bopisDisplay);
}

//TODO: we use this function to update stuff after the usersLocation is reset, soooo do we need to update this to update closestBopisLocation
//prep and set stores data into session storage
function prepareStoresData(stores, userLocation, injectClosestStore = true, assignPreferredStore = true) {
    console.log("debug - prepareStoresData");

    let preferredStore = stores?.preferred;
    stores = stores?.openStores

    // Assign closest store to first location in coordinates array as default, and remove it from array
    let closestStore = { 
        distance: pythagoreanDistanceBetweenPoints(stores[0].lat, stores[0].lon, userLocation.lat, userLocation.lon),
        title: stores[0].title,
        rel_url: stores[0].rel_url
    };

    stores.forEach((store, i) => {
        storeDistance = pythagoreanDistanceBetweenPoints(store.lat, store.lon, userLocation.lat, userLocation.lon);
        stores[i].distance = storeDistance; //add/update distance item to original data
        
        if (storeDistance < closestStore.distance) {
            closestStore = { 
                distance: storeDistance,
                title: store.title,
                rel_url: store.rel_url
            };
        }
    });

    if (assignPreferredStore == true){
        window.sessionStorage.setItem("stores", JSON.stringify({
            preferred: closestStore,
            openStores: stores
        }));
    } else {
        window.sessionStorage.setItem("stores", JSON.stringify({
            preferred: preferredStore ? preferredStore : closestStore,
            openStores: stores
        }));
    }

    if (injectClosestStore == true) {
        injectLocationWidget(closestStore);
    }
}

//display function for location widgets
function injectLocationWidget(preferredStore) {
    console.log("debug - injectLocationWidget");

    let locationWidgets = document.querySelectorAll("location-widget");
    locationWidgets.forEach((widget) => {
        if (typeof widget.injectClosestStore === 'function') {
            widget.injectClosestStore( preferredStore );
        }
    })
}

//display function for bopis
function setBopisCssVariable(display) {
    console.log("debug - setBopisCssVariable");

    document.body.style.setProperty("--bopis-display", display);
}

//helper function
function pythagoreanDistanceBetweenPoints(lat1, lon1, lat2, lon2) {
    lat1 = parseFloat(lat1);
    lon1 = parseFloat(lon1);
    lat2 = parseFloat(lat2);
    lon2 = parseFloat(lon2);

    const radlat1 = Math.PI * lat1 / 180;
    const radlat2 = Math.PI * lat2 / 180;
    const theta = lon1 - lon2;
    const radtheta = Math.PI * theta / 180;
    let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.min(1, dist); // Ensure dist is within [-1, 1] range
    dist = Math.acos(dist) * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    dist = (dist * 0.8684) * 1.15077945; // Convert to miles
    return dist;
}